(() => {
  const initialiseFeedbackSection = (section) => {
    if (!section || section.dataset.lsPageFeedbackReady === 'true') return;

    const dialog = section.querySelector('[data-ls-page-feedback-dialog]');
    const openButton = section.querySelector('[data-ls-page-feedback-open]');
    const closeButtons = section.querySelectorAll('[data-ls-page-feedback-close]');
    const form = section.querySelector('form');
    const pageUrlField = section.querySelector('[data-ls-feedback-url]');
    const deviceField = section.querySelector('[data-ls-feedback-device]');
    const timeField = section.querySelector('[data-ls-feedback-time]');
    const honeypot = section.querySelector('[data-ls-feedback-honeypot]');
const successTemplate = section.querySelector(
  '[data-ls-page-feedback-success-template]'
);

const submissionStorageKey = `ls-page-feedback-submitted:${section.id}`;
    const reopenStorageKey = `ls-page-feedback-reopen:${section.id}`;

    const getStorageFlag = (key) => {
      try {
        return sessionStorage.getItem(key) === '1';
      } catch (error) {
        return false;
      }
    };

    const setStorageFlag = (key) => {
      try {
        sessionStorage.setItem(key, '1');
      } catch (error) {
        /* Storage may be unavailable in some browsing modes. */
      }
    };

    const clearStorageFlag = (key) => {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {
        /* Nothing to clear. */
      }
    };

    const hasContactPosted = () =>
      new URLSearchParams(window.location.search).get('contact_posted') === 'true';

    const reloadWithCleanContactState = () => {
      const url = new URL(window.location.href);

      url.searchParams.delete('contact_posted');
      url.hash = section.id;

      setStorageFlag(reopenStorageKey);
      window.location.replace(url.toString());
    };

    if (!dialog || !openButton) return;

    section.dataset.lsPageFeedbackReady = 'true';

    const refreshMetadata = () => {
      if (pageUrlField) pageUrlField.value = window.location.href;

      if (deviceField) {
        const isTouch = window.matchMedia('(pointer: coarse)').matches;
        const deviceType = isTouch ? 'Mobile or tablet' : 'Desktop';
        deviceField.value = `${deviceType}; ${window.screen.width}x${window.screen.height}; ${navigator.userAgent}`;
      }

      if (timeField) timeField.value = new Date().toISOString();
    };

    const openDialog = () => {
      refreshMetadata();

      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      const status = dialog.querySelector('[data-ls-page-feedback-status]');
      const firstField = dialog.querySelector('select, textarea, input:not([type="hidden"])');
      window.requestAnimationFrame(() => (status || firstField || dialog).focus({ preventScroll: true }));
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };
 const showSuccessDialog = () => {
  if (!successTemplate) return;

  dialog.dataset.lsFeedbackSuccess = 'true';

  dialog.replaceChildren(
    successTemplate.content.cloneNode(true)
  );

  dialog
    .querySelectorAll('[data-ls-page-feedback-close]')
    .forEach((button) => {
      button.addEventListener('click', closeDialog);
    });

  openDialog();
};

        openButton.addEventListener('click', () => {
      /*
       * Shopify uses the same contact_posted state for every contact form
       * on the page. If another contact form was just submitted, reload
       * once without that state before opening the feedback form.
       */
      if (
  hasContactPosted() ||
  dialog.dataset.lsFeedbackSuccess === 'true'
) {
  reloadWithCleanContactState();
  return;
}

      openDialog();
    });
    closeButtons.forEach((button) => button.addEventListener('click', closeDialog));

    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;

      const rect = dialog.getBoundingClientRect();
      const clickedInside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!clickedInside) closeDialog();
    });

        if (form) {
      form.addEventListener('submit', (event) => {
        refreshMetadata();

        if (honeypot && honeypot.value.trim() !== '') {
          event.preventDefault();
          clearStorageFlag(submissionStorageKey);
          closeDialog();
          return;
        }

        /*
         * Remember that THIS contact form was submitted.
         * Shopify itself does not distinguish between multiple contact forms
         * when it returns with contact_posted=true.
         */
        setStorageFlag(submissionStorageKey);
      });
    }

const feedbackSubmissionReturned = getStorageFlag(
  submissionStorageKey
);

const reopenAfterReload = getStorageFlag(
  reopenStorageKey
);

const isFeedbackReturn =
  window.location.hash === `#${section.id}`;

if (feedbackSubmissionReturned) {
  /*
   * THIS browser submitted the Page Feedback form immediately before
   * this page load. Shopify does not reliably distinguish multiple
   * contact forms, so our own submission marker is authoritative.
   */
  const feedbackError = dialog.querySelector(
    '.ls-page-feedback__status--error'
  );

  clearStorageFlag(submissionStorageKey);

  /*
   * Shopify may incorrectly mark the normal Contact Us form as
   * successful after the Page Feedback form is submitted.
   */
  const standardContactSuccess = document
    .getElementById('ContactForm')
    ?.querySelector('.form-status.form__message');

  if (standardContactSuccess) {
    standardContactSuccess.hidden = true;
  }

  if (feedbackError) {
    /*
     * Shopify actually returned validation/server errors for the
     * feedback submission, so show those instead of claiming success.
     */
    openDialog();
  } else {
    /*
     * The Page Feedback form was submitted and Shopify returned no
     * feedback-form errors. Show our translated success confirmation.
     */
    showSuccessDialog();
  }
} else if (reopenAfterReload) {
  clearStorageFlag(reopenStorageKey);

  /*
   * We reloaded only to clear another contact form's Shopify success
   * state. Open a fresh Page Feedback form.
   */
  openDialog();
} else if (
  dialog.dataset.openOnLoad === 'true' &&
  isFeedbackReturn
) {
  /*
   * Fallback for browsers where sessionStorage is unavailable.
   * Only trust Shopify's rendered state when the return URL points
   * specifically to the Page Feedback section.
   */
  const feedbackError = dialog.querySelector(
    '.ls-page-feedback__status--error'
  );

  if (!feedbackError) {
    dialog.dataset.lsFeedbackSuccess = 'true';
  }

  openDialog();
} else {
  /*
   * Do not show another Shopify contact form's errors inside
   * the Page Feedback dialog.
   */
  const feedbackError = dialog.querySelector(
    '.ls-page-feedback__status--error'
  );

  if (feedbackError) {
    feedbackError.hidden = true;
  }
}
  };

  const initialiseAllFeedbackSections = (root = document) => {
    root.querySelectorAll('[data-ls-page-feedback]').forEach(initialiseFeedbackSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAllFeedbackSections());
  } else {
    initialiseAllFeedbackSections();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAllFeedbackSections(event.target));
})();
